import { ThemesContent } from '../types';

export const VRGPA: ThemesContent = {
  colors: {
    light: '#F05A28',
    copyRightColor: 'white',
    privacyColor: 'white',
  },
};
